/* global __SALESFORCE_REDIRECT_URI */
import * as R from 'ramda';

export default function userBarController(
  $location,
  $q,
  $rootScope,
  $route,
  $scope,
  $window,
  $timeout,

  addSupportTicketDialog,
  alerts,
  appVersionService,
  authorizationService,
  contactUsDialog,
  switchBanksDialog,
  loaderService,
  orgDataService,
  orgSharedModelService,
  ssDialogService,
  userService,
  navUiState,
) {
  const vm = this;

  vm.handleTheSafeLogoClick = _handleTheSafeLogoClick;
  vm.handleNavLinkClick = _handleNavLinkClick;
  vm.handleExternalNavLinkClick = _handleExternalNavLinkClick;
  vm.handleLogOutClick = _handleLogOutClick;
  vm.handleSwitchBanksClick = _handleSwitchBanksClick;
  vm.handleResetImpersonationClick = _handleResetImpersonationClick;
  vm.buildNavTree = _buildNavTree;

  vm.authorizationService = authorizationService;
  vm.userService = userService;
  vm.ui = navUiState;
  vm.helpMenu = [];
  vm.displayList = null;
  vm.refreshTicket = null;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleTheSafeLogoClick() {
    $location.path('/home');
  }

  function _handleNavLinkClick($event, navigationLink) {
    vm.ui.dismissed = true;
    if ($event && $event.currentTarget) $event.currentTarget.blur();
    if (!navigationLink.hasChildren) {
      //$event.stopPropagation();
      if (navigationLink.anchorURL && navigationLink.anchorURL.length > 0) {
        // Log navigation destination, unless navigating to Home.
        if (navigationLink.navigationId > 1) {
          orgDataService.logUserNavigation(userService.user.userId, navigationLink.navigationId);
        }
        // MAC: Changed to 'url' instead of 'Path' as Path will keep the Query-string parameters
        if (navigationLink.anchorURL === 'support/tickets') {
          if ($rootScope.isAzureLog === true) {
            $window.open(__SALESFORCE_REDIRECT_URI, '_blank');
          } else {
            alerts.error('You must be an Azure AD Authenticated User to access Ticketing.');
          }
        } else {
          //$location.url(navigationLink.anchorURL);
        }
      }
    }
  }

  function _handleExternalNavLinkClick(navigationLink) {
    if (!navigationLink.hasChildren) {
      $window.open(navigationLink.linkOrScript, '_blank');
    }
  }

  function _handleSwitchBanksClick($event) {
    loaderService.showViewLoader = true;
    orgDataService.getAssignedBanks(userService.user.userId).then(getAssignedBanksResponse => {
      _showSwitchBanksDialog($event, {
        assignedBanks: getAssignedBanksResponse.data,
      });
      loaderService.showViewLoader = false;
    });
  }

  function _handleResetImpersonationClick() {
    loaderService.showViewLoader = true;
    orgDataService
      .resetImpersonation()
      .then(response => {
        if (response.status === 200) {
          const token = {
            userName: userService.user.loginName,
            access_token: response.data.access_token,
            access_token_expires_in: response.data.access_token_expires_in,
            expires_in: response.data.expires_in,
          };
          authorizationService.setToken(token);
          userService.refreshUser().then(() => {
            $rootScope.$broadcast('loggedIn');
            if ($location.$$path === '/home') {
              $route.reload();
            }
            $location.path('/home');
          });
        }
      })
      .catch(() => {
        authorizationService.revokeToken();
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleLogOutClick() {
    loaderService.showViewLoader = true;
    orgDataService.logout().then(
      () => {
        authorizationService.revokeToken();
        userService.reset();
        $location.path('/login');
        $rootScope.$broadcast('loggedOut');
        $timeout(() => {
          angular.element('html')[0].scrollTop = 0;
        }, 0);
        loaderService.showViewLoader = false;
      },
      () => {
        authorizationService.revokeToken();
        $location.path('/login');
        $rootScope.$broadcast('loggedOut');
        loaderService.showViewLoader = false;
      },
    );
  }

  function _handleShowAddTicketClick($event) {
    $scope.contextualHelpNavActive = false;
    return _showAddSupportTicketDialog($event);
  }

  function _handleContactUsClick($event) {
    $scope.contextualHelpNavActive = false;
    return _showContactUsDialog($event);
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _refreshUserBar();
    $scope.$on('loggedIn', _refreshUserBar);
  }

  function _refreshUserBar() {
    if (authorizationService.getToken()) {
      userService.getUser().then(user => {
        vm.tree = _buildNavTree(vm.userService.user.navigation);
        _getNavigationBySupport();
        _getCustomerProperties(user.customerId);
        // _seedFakeNav();
      });
    }
  }

  function _getNavigationBySupport() {
    vm.helpMenu = [];
    let supportTicketNav = null;

    if (!R.isNil(userService.user.navigation)) {
      supportTicketNav = R.find(R.propEq('navigationId', 25), userService.user.navigation);
    }
    if (!R.isNil(supportTicketNav)) {
      vm.helpMenu.push(supportTicketNav);
      vm.helpMenu.push({
        displayName: 'Create Support Ticket',
        anchorURL: '',
        onClick: $event => {
          _handleShowAddTicketClick($event);
        },
        hasChildren: false,
      });
    }
    vm.helpMenu.push({
      displayName: 'Contact Us',
      anchorURL: '',
      onClick: $event => {
        _handleContactUsClick($event);
      },
      hasChildren: false,
    });
  }

  function _getCustomerProperties(customerId) {
    orgSharedModelService.getCustomer(customerId, true).then(customer => {
      vm.canSubmitTickets = customer.canSubmitTickets;
      $rootScope.canDoSalesforceTicketing = customer.canDoSalesforceTicketing;
    });
  }

  function _showAddSupportTicketDialog($event) {
    if (vm.canSubmitTickets) {
      const ticket = {
        id: '',
        priorityId: '',
        title: '',
        description: '',
        contactId: '',
        statusId: '',
        serviceRequestType: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        past30Days: 'no',
        affectingMultiple: 'no',
        contactDetails: '',
      };

      ssDialogService.dialogs.support.addSupportTicketDialog = ssDialogService.alert(
        addSupportTicketDialog.getOptions($event, {
          ticketType: 1,
          ticket,
          displayList: vm.displayList,
          refreshTicket: vm.refreshTicket,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.support.addSupportTicketDialog);
    } else {
      alerts.error('This customer cannot add tickets in this environment. Please contact your system administrator.');
    }
  }

  function _showContactUsDialog($event) {
    ssDialogService.dialogs.membership.contactUsDialog = ssDialogService.alert(contactUsDialog.getOptions($event, {}));
    return ssDialogService.show(ssDialogService.dialogs.membership.contactUsDialog);
  }

  function _showSwitchBanksDialog($event, locals) {
    ssDialogService.dialogs.membership.switchBanksDialog = ssDialogService.alert(
      switchBanksDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.membership.switchBanksDialog);
  }

  function _buildNavTree(flat) {
    var internal = flat.filter(function (n) {
      return !n.external;
    });

    var byParent = {};
    internal.forEach(function (n) {
      var key = n.parentNavigationId == null ? 'root' : n.parentNavigationId;
      (byParent[key] = byParent[key] || []).push(n);
    });

    function build(key) {
      return (byParent[key] || [])
        .sort(function (a, b) {
          return a.sortOrder - b.sortOrder;
        })
        .map(function (n) {
          return angular.extend({}, n, {
            children: n.hasChildren ? build(n.navigationId) : [],
          });
        });
    }
    var tree = build('root');

    var externals = flat
      .filter(function (n) {
        return n.external;
      })
      .sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      })
      .map(function (n) {
        return angular.extend({}, n, { children: [] });
      });

    if (externals.length) {
      tree.push({
        displayName: 'External Links',
        hasChildren: true,
        navigationId: 'external-links',
        external: false,
        children: externals,
      });
    }

    return tree;
  }
}

userBarController.$inject = [
  '$location',
  '$q',
  '$rootScope',
  '$route',
  '$scope',
  '$window',
  '$timeout',

  'addSupportTicketDialog',
  'alerts',
  'appVersionService',
  'authorizationService',
  'contactUsDialog',
  'switchBanksDialog',
  'loaderService',
  'orgDataService',
  'orgSharedModelService',
  'ssDialogService',
  'userService',
  'navUiState',
];
